const Filter = (function () {

    const $ = require('jquery');
    const Template = require('./../lib/template');
    //  Location Manager (https://github.com/KidkArolis/location-bar)
    const LocationBar = require('./../lib/location-bar');
    const self = {};
    const $filter = $('[data-ajax-area]');
    const locationBar = new LocationBar();

    self.init = function () {

        //  Check if filter exists
        if ($filter.length > 0) {

            self.postType = $filter.data('post-type');

            self.ajaxOnPageLoad = ($filter.data('ajax-onload') === true);
            self.$resultHolder = $filter.find('[data-results-holder]');
            self.$paginationHolder = $filter.find('[data-pagination-holder]');

            let $filterForm = $filter.find('[data-filter-form]');
            let $filterFormFields = $filterForm.find('input[type="checkbox"], input[type="radio"], select');

            locationBar.start({
                pushState: true
            });

            //  Makes initial load of archive my Ajax
            if (self.ajaxOnPageLoad) {

                self.loadTemplate(window.location.href, false);

            }

            //  Ajax the changed URL
            locationBar.onChange(function (path) {

                self.loadTemplate((!path.startsWith('/') ? '/' : '') + path, true);

            });

            //  Handle all field of the form to process the filters (taxonomies)
            $filterFormFields.on('change', function () {
                $filterForm.submit();
            });

            //  Handle form submit
            $filterForm.on('submit', function (ev) {
                ev.preventDefault();

                let hash = window.location.hash;
                let pathname = window.location.pathname;
                //  Strip paginator from filter.
                //  When you're on page 2 and use the filter you need a new search, not a filtered page 2
                let url = pathname.replace(/page\/[0-9]\//g, '');

                //  Serialized form data
                let data = $(this).find(':input').filter(function (index, element) {
                    return $(element).val() != '';
                }).serialize();

                if (data) {
                    url += '?' + decodeURIComponent(data);
                }

                if (hash) {
                    url += hash;
                }

                //  Update URL
                locationBar.update(url, {trigger: true});
            });

            //  Handle paginator
            self.$paginationHolder.on('click', 'a', function (ev) {
                ev.preventDefault();

                let href = this.href;
                let url = href.replace(/^.*\/\/[^\/]+/, '');
                let suffix = '';
                let hash = window.location.hash;

                if (hash) {
                    suffix = hash;
                }

                //  Update URL
                locationBar.update(url + suffix, {trigger: true});
            });

        }

    };

    self.loadTemplate = function (path, viaAjax) {

        if (viaAjax) {
            App.Globals.$document.trigger('site:filter:start', path);
        }

        if (App.Globals.debug) {
            console.log('path: ' + path);
        }

        $.ajax({
            url: path,
            data: {
                json: true
            },
            dataType: 'json'
        }).done(function (data) {

            Template.render(self.$resultHolder, rk_globals.theme_path + '/views/parts/' + self.postType + '/set.twig', data);
            Template.render(self.$paginationHolder, rk_globals.theme_path + '/views/parts/pagination.twig', data);

            if (viaAjax) {
                App.Globals.$document.trigger('site:filter:end', path);
            }

            //  Scroll to the top of the results
            App.Globals.$scrollAnimators.animate({
                scrollTop: $filter.offset().top - $('#header').height()
            });

        });

    };

    return self;

}());

module.exports = Filter;
